module.exports = __webpack_public_path__ + "img/loading1.afee0e67.gif";